export const pnaAnaPtBR = {
  eyebrow: 'MC · PNA–ANA · módulo experimental isolado',
  atlas: {
    title: 'Mudança do clima no ICPM: antes e depois',
    description: 'Compare as oito versões do ICPM com o componente climático anterior e com o impacto municipal de cheias e inundações do PNA, calculado pela ANA com apoio do IPH/UFRGS.',
  },
  nav: {
    atlas: 'Atlas comparativo',
    classes: 'Ver classes do PNA',
    robustness: 'Abrir robustez',
  },
  download: 'Baixar os oito modelos',
  noticeTitle: 'Experimento separado; o ICPM adotado permanece intacto',
  notice: 'Esta área substitui somente o componente de mudança do clima para testar o ishmax_min. Nenhuma página oficial, base canônica adotada ou corte vigente foi sobrescrito.',
  version: 'mc-pna-ana {{version}} · resultados experimentais · baseline preservado',
  before: 'Antes',
  after: 'Com PNA–ANA',
  families: {
    original: 'ICM categórico',
    numeric: 'ICM numérico',
  },
  references: {
    national: 'Brasil',
    population: 'Porte populacional',
    population_region: 'Porte + macrorregião',
    population_gdp: 'Porte + PIB per capita',
  },
  metrics: {
    coverage: 'Cobertura comparável',
    coverageDetail: '{{classified}} de {{total}} municípios',
    rankStability: 'Correlação de ranks',
    topOverlap: '{{count}} municípios coincidem no top 100',
    quintileOverlap: '{{count}} coincidem no quinto superior ({{percentage}}%)',
    changed: 'Mudanças na seleção',
    entriesExits: '{{entries}} entradas · {{exits}} saídas',
    casaCivil: 'Casa Civil selecionados',
    casaCivilDetail: 'eram {{old}} na versão anterior',
    selected: 'Selecionados',
  },
  map: {
    title: 'Tríptico territorial comparável',
    description: 'Os três mapas usam a mesma malha e o mesmo critério: escore anterior, escore com PNA–ANA e variação absoluta. Cinza indica ausência de classificação na fonte.',
    modeSelector: 'Escolha entre os três mapas comparativos',
    modes: {
      old: '1 · ICPM anterior',
      new: '2 · ICPM com PNA–ANA',
      delta: '3 · Diferença no escore',
      class: 'Classes da Figura 13',
    },
    modeDetails: {
      old: 'Base de comparação sem alterar seus valores publicados.',
      new: 'Mesmos pesos; apenas o componente climático é substituído.',
      delta: 'Magenta aumenta a prioridade; azul reduz a prioridade.',
    },
    performanceNote: 'Os três modos compartilham um único mapa vetorial PMTiles. Isso mantém a comparação completa e evita três contextos WebGL simultâneos, melhorando a navegação.',
    instructions: 'Arraste para navegar, use a roda com a tecla de modificação para ampliar e clique em um município para abrir sua ficha.',
    noClassification: 'Sem classificação na fonte PNA–ANA',
    popupRaw: 'ishmax_min: {{value}}',
    popupScores: 'Escore: {{old}} → {{new}}',
    popupRanks: 'Rank comparável: #{{old}} → #{{new}} · movimento {{gain}}',
    deltaLower: 'redução ≥ 0,03',
    deltaStable: 'próximo de zero',
    deltaHigher: 'aumento ≥ 0,03',
  },
  classes: {
    sem_classificacao: 'Sem classificação',
    emergencial: 'Emergencial',
    critica: 'Crítica',
    alerta: 'Alerta',
    cautela: 'Cautela',
    sem_impacto: 'Sem impacto',
  },
  selection: {
    title: 'Efeito no corte fixo de 0,300',
    description: 'Entradas e saídas são calculadas apenas no universo com valor PNA–ANA disponível.',
  },
  transitions: {
    entered: 'Entrou',
    exited: 'Saiu',
    remained_selected: 'Permaneceu selecionado',
    remained_outside: 'Permaneceu fora',
    unavailable: 'Sem comparação',
  },
  method: {
    title: 'Polaridade corrigida',
    description: 'Como valores menores representam maior impacto futuro, a escala é invertida antes de entrar no ICPM. A transformação linear preserva os intervalos teóricos de uma unidade.',
    rawScale: 'Escala de origem',
    weight: 'Peso no ICPM',
    comparable: 'Universo comparável',
  },
  filters: {
    criterion: 'Versão do ICPM',
    search: 'Buscar município ou código',
    allRegions: 'Todas as macrorregiões',
    allClasses: 'Todas as classes',
    allTransitions: 'Todas as transições',
    sort: 'Ordenação',
    casaCivilOnly: 'Mostrar somente municípios da lista da Casa Civil',
  },
  sort: {
    new_rank: 'Rank com PNA–ANA',
    old_rank: 'Rank anterior comparável',
    rank_gain: 'Maiores ganhos de posição',
    rank_loss: 'Maiores perdas de posição',
    score_delta: 'Maior aumento do escore',
    municipality_name: 'Nome do município',
  },
  table: {
    title: 'Ranking municipal antes × depois',
    results: 'resultados',
    municipality: 'Município',
    class: 'Classe PNA',
    raw: 'ishmax_min',
    rankMovement: 'Movimento',
    transition: 'Seleção',
    cohort: 'Coorte comparável',
    region: 'Macrorregião',
  },
  casaCivilBadge: 'Casa Civil',
  municipality: {
    title: 'Impacto da substituição climática neste município',
    description: 'Leitura experimental do ICM numérico · Brasil, mantendo lado a lado o escore anterior e o resultado com ishmax_min.',
    openAtlas: 'Abrir no atlas comparativo',
    raw: 'Valor de origem',
    priority: 'Prioridade climática',
    movement: 'Movimento de rank',
  },
  classPage: {
    title: 'Classes municipais de impacto climático do PNA',
    description: 'Reprodução analítica da Figura 13 com a paleta original, limites explícitos, distribuição regional e auditoria dos municípios sem classificação.',
    emergency: 'Classe emergencial',
    lowerRaw: 'menores valores · maior prioridade',
    unclassified: 'Sem classificação',
    noImputation: 'mantidos sem imputação',
    colors: 'Paleta original',
    qmlPalette: 'cores extraídas do estilo QGIS',
    mapTitle: 'Impacto futuro de cheias e inundações',
    mapDescription: 'Emergencial é a condição mais preocupante. A leitura territorial preserva as cores publicadas no estilo da Figura 13.',
    legend: 'Classes e frequências do PNA',
    noValue: 'sem valor numérico',
    interval: '{{min}} a {{max}}',
    regionalTitle: 'Composição das classes por macrorregião',
    regionalDescription: 'Contagem municipal; a diferença de tamanho entre regiões deve ser considerada.',
    polarityTitle: 'Da escala do PNA à prioridade do ICPM',
    polarityDescription: 'O PNA diminui quando o impacto aumenta. O ICPM aumenta quando a prioridade aumenta. A inversão alinha as duas leituras.',
    polarityNote: 'Exemplo: ishmax_min = 1 gera prioridade 1,00; ishmax_min = 5 gera prioridade 0,00.',
    missingTitle: 'Cobertura sem esconder ausências',
    missingDescription: 'São 64 polígonos sem classe e dois municípios ausentes da Figura 13 entregue. Eles não recebem valor artificial e ficam fora dos ranks comparáveis.',
    sourceStatus: 'Situação na fonte',
    databaseTitle: 'Leitura direta do banco ainda depende de permissão',
    databaseDescription: 'O usuário fornecido conecta ao PostgreSQL, mas não possui USAGE no schema pna_ana. Esta versão usa a cópia municipal da Figura 13 entregue com a minuta e registra hashes dos arquivos.',
  },
  sourceStatus: {
    unclassified_in_source: 'Polígono presente, valor nulo',
    municipality_absent_from_figure_13: 'Município ausente da Figura 13',
    classified: 'Classificado',
  },
  scenarios: {
    theoretical_linear: 'Linear teórica',
    empirical_percentile: 'Percentil empírico',
    class_steps: 'Degraus por classe',
  },
  robustness: {
    title: 'Robustez da normalização climática',
    description: 'Teste quanto rankings e seleções dependem da forma de transformar ishmax_min antes de incorporar o componente ao ICPM numérico nacional.',
    primaryTitle: 'A escala linear teórica é a especificação principal',
    primaryDescription: 'Ela respeita os limites 1–5, preserva a distância entre classes e mantém o significado absoluto do corte. As alternativas são diagnósticos, não substituições automáticas.',
    primarySelected: 'Seleção principal',
    empiricalSelected: 'Seleção por percentil',
    classSelected: 'Seleção por classes',
    difference: '{{value}} em relação à principal',
    classTopOverlap: 'Coincidência no top 100',
    rankCorrelation: 'Spearman {{value}}',
    chartTitle: 'Volume selecionado e estabilidade do topo',
    chartDescription: 'O percentil altera a escala absoluta do componente; os degraus descartam diferenças dentro da mesma classe.',
    selected: 'Municípios selecionados',
    topOverlap: 'Coincidência top 100',
    tradeoffsTitle: 'O que cada escolha preserva',
    scenarioDetails: {
      theoretical_linear: 'Preserva a escala 1–5 e os intervalos de uma unidade. É transportável e adotada no experimento.',
      empirical_percentile: 'Preserva a ordem observada, mas força média próxima de 0,5 e torna o corte dependente desta amostra.',
      class_steps: 'Replica a comunicação por classes e cores, porém empata municípios e perde a variação interna.',
    },
    sensitiveTitle: 'Municípios mais sensíveis à transformação',
    sensitiveDescription: 'A amplitude é a diferença entre o melhor e o pior rank nas três normalizações.',
    rankSpread: 'Amplitude de rank',
    conclusionTitle: 'Leitura recomendada',
    conclusion: 'A escolha de normalização afeta principalmente o volume acima do corte: a correlação de rank permanece alta, mas o percentil empírico reduz substancialmente os selecionados. Por isso, a escala linear teórica é mais coerente para a comparação principal, enquanto as outras duas devem permanecer como faixas de sensibilidade.',
  },
} as const

export const pnaAnaEn = {
  eyebrow: 'MC · PNA–ANA · isolated experimental module',
  atlas: {
    title: 'Climate change in the ICPM: before and after',
    description: 'Compare all eight ICPM versions using the previous climate component and the municipal flood-impact result from the PNA, developed by ANA with IPH/UFRGS support.',
  },
  nav: {
    atlas: 'Comparison atlas',
    classes: 'View PNA classes',
    robustness: 'Open robustness',
  },
  download: 'Download eight models',
  noticeTitle: 'Separate experiment; the adopted ICPM remains intact',
  notice: 'This area replaces only the climate-change component to test ishmax_min. No adopted page, canonical baseline or current cutoff was overwritten.',
  version: 'mc-pna-ana {{version}} · experimental results · preserved baseline',
  before: 'Before',
  after: 'With PNA–ANA',
  families: {
    original: 'Categorical ICM',
    numeric: 'Numeric ICM',
  },
  references: {
    national: 'Brazil',
    population: 'Population size',
    population_region: 'Size + macroregion',
    population_gdp: 'Size + GDP per capita',
  },
  metrics: {
    coverage: 'Comparable coverage',
    coverageDetail: '{{classified}} of {{total}} municipalities',
    rankStability: 'Rank correlation',
    topOverlap: '{{count}} municipalities overlap in the top 100',
    quintileOverlap: '{{count}} overlap in the upper quintile ({{percentage}}%)',
    changed: 'Selection changes',
    entriesExits: '{{entries}} entries · {{exits}} exits',
    casaCivil: 'Casa Civil selected',
    casaCivilDetail: '{{old}} in the previous version',
    selected: 'Selected',
  },
  map: {
    title: 'Comparable territorial triptych',
    description: 'All three maps use the same geometry and criterion: previous score, PNA–ANA score and absolute difference. Gray means no source classification.',
    modeSelector: 'Choose among the three comparison maps',
    modes: {
      old: '1 · Previous ICPM',
      new: '2 · ICPM with PNA–ANA',
      delta: '3 · Score difference',
      class: 'Figure 13 classes',
    },
    modeDetails: {
      old: 'Comparison baseline with published values unchanged.',
      new: 'Same weights; only the climate component is replaced.',
      delta: 'Magenta increases priority; blue decreases priority.',
    },
    performanceNote: 'All three modes share one PMTiles vector map. This preserves the full comparison while avoiding three simultaneous WebGL contexts for faster navigation.',
    instructions: 'Drag to navigate, use the modifier key with the wheel to zoom and click a municipality to open its profile.',
    noClassification: 'No PNA–ANA source classification',
    popupRaw: 'ishmax_min: {{value}}',
    popupScores: 'Score: {{old}} → {{new}}',
    popupRanks: 'Comparable rank: #{{old}} → #{{new}} · movement {{gain}}',
    deltaLower: 'decrease ≥ 0.03',
    deltaStable: 'near zero',
    deltaHigher: 'increase ≥ 0.03',
  },
  classes: {
    sem_classificacao: 'Unclassified',
    emergencial: 'Emergency',
    critica: 'Critical',
    alerta: 'Alert',
    cautela: 'Caution',
    sem_impacto: 'No impact',
  },
  selection: {
    title: 'Effect at the fixed 0.300 cutoff',
    description: 'Entries and exits are calculated only within the universe with an available PNA–ANA value.',
  },
  transitions: {
    entered: 'Entered',
    exited: 'Exited',
    remained_selected: 'Remained selected',
    remained_outside: 'Remained outside',
    unavailable: 'Not comparable',
  },
  method: {
    title: 'Corrected polarity',
    description: 'Because lower values mean larger future impacts, the scale is reversed before entering the ICPM. The linear transformation preserves the theoretical one-unit intervals.',
    rawScale: 'Source scale',
    weight: 'ICPM weight',
    comparable: 'Comparable universe',
  },
  filters: {
    criterion: 'ICPM version',
    search: 'Search municipality or code',
    allRegions: 'All macroregions',
    allClasses: 'All classes',
    allTransitions: 'All transitions',
    sort: 'Sort order',
    casaCivilOnly: 'Show Casa Civil municipalities only',
  },
  sort: {
    new_rank: 'PNA–ANA rank',
    old_rank: 'Previous comparable rank',
    rank_gain: 'Largest rank gains',
    rank_loss: 'Largest rank losses',
    score_delta: 'Largest score increase',
    municipality_name: 'Municipality name',
  },
  table: {
    title: 'Municipal ranking before × after',
    results: 'results',
    municipality: 'Municipality',
    class: 'PNA class',
    raw: 'ishmax_min',
    rankMovement: 'Movement',
    transition: 'Selection',
    cohort: 'Comparable cohort',
    region: 'Macroregion',
  },
  casaCivilBadge: 'Casa Civil',
  municipality: {
    title: 'Climate replacement impact for this municipality',
    description: 'Experimental numeric-ICM · Brazil view, keeping the previous score and the ishmax_min result side by side.',
    openAtlas: 'Open in comparison atlas',
    raw: 'Source value',
    priority: 'Climate priority',
    movement: 'Rank movement',
  },
  classPage: {
    title: 'PNA municipal climate-impact classes',
    description: 'Analytical reproduction of Figure 13 with its original palette, explicit thresholds, regional distribution and an audit of unclassified municipalities.',
    emergency: 'Emergency class',
    lowerRaw: 'lower values · higher priority',
    unclassified: 'Unclassified',
    noImputation: 'kept without imputation',
    colors: 'Original palette',
    qmlPalette: 'colors extracted from the QGIS style',
    mapTitle: 'Future flood impact',
    mapDescription: 'Emergency is the most concerning condition. The territorial view preserves the colors published in the Figure 13 style.',
    legend: 'PNA classes and frequencies',
    noValue: 'no numeric value',
    interval: '{{min}} to {{max}}',
    regionalTitle: 'Class composition by macroregion',
    regionalDescription: 'Municipal counts; regional size differences should be considered.',
    polarityTitle: 'From the PNA scale to ICPM priority',
    polarityDescription: 'The PNA decreases as impact increases. ICPM increases as priority increases. Reversal aligns both readings.',
    polarityNote: 'Example: ishmax_min = 1 yields priority 1.00; ishmax_min = 5 yields priority 0.00.',
    missingTitle: 'Coverage without hiding gaps',
    missingDescription: 'There are 64 polygons without a class and two municipalities absent from the delivered Figure 13. They receive no artificial value and stay out of comparable ranks.',
    sourceStatus: 'Source status',
    databaseTitle: 'Direct database reads still require permission',
    databaseDescription: 'The supplied user connects to PostgreSQL but lacks USAGE on schema pna_ana. This version uses the municipal Figure 13 copy delivered with the draft and records file hashes.',
  },
  sourceStatus: {
    unclassified_in_source: 'Polygon present, null value',
    municipality_absent_from_figure_13: 'Municipality absent from Figure 13',
    classified: 'Classified',
  },
  scenarios: {
    theoretical_linear: 'Theoretical linear',
    empirical_percentile: 'Empirical percentile',
    class_steps: 'Class steps',
  },
  robustness: {
    title: 'Climate normalization robustness',
    description: 'Test how rankings and selections depend on the ishmax_min transformation before it enters the national numeric-ICM ICPM.',
    primaryTitle: 'The theoretical linear scale is the primary specification',
    primaryDescription: 'It respects the 1–5 limits, preserves distances between classes and keeps the absolute meaning of the cutoff. Alternatives are diagnostics, not automatic replacements.',
    primarySelected: 'Primary selection',
    empiricalSelected: 'Percentile selection',
    classSelected: 'Class-based selection',
    difference: '{{value}} versus primary',
    classTopOverlap: 'Top-100 overlap',
    rankCorrelation: 'Spearman {{value}}',
    chartTitle: 'Selected volume and top-rank stability',
    chartDescription: 'The percentile changes the component’s absolute scale; class steps discard within-class differences.',
    selected: 'Selected municipalities',
    topOverlap: 'Top-100 overlap',
    tradeoffsTitle: 'What each choice preserves',
    scenarioDetails: {
      theoretical_linear: 'Preserves the 1–5 scale and one-unit intervals. It is portable and adopted in the experiment.',
      empirical_percentile: 'Preserves observed order but forces a mean near 0.5 and makes the cutoff sample-dependent.',
      class_steps: 'Replicates class and color communication but ties municipalities and loses within-class variation.',
    },
    sensitiveTitle: 'Municipalities most sensitive to transformation',
    sensitiveDescription: 'The spread is the difference between best and worst rank under the three normalizations.',
    rankSpread: 'Rank spread',
    conclusionTitle: 'Recommended reading',
    conclusion: 'Normalization mainly affects volume above the cutoff: rank correlation stays high, but the empirical percentile substantially reduces the selected set. The theoretical linear scale is therefore more coherent for the primary comparison, while the other two should remain sensitivity bounds.',
  },
} as const
